<template>
  <el-dialog
    title="规则适用商品"
    :visible.sync="showDialog"
    :before-close="cancelAction"
    width="1025px"
    append-to-body
  >
    <!-- 查询区 -->
    <ul class="search-btn">
      <li>
        <span class="m-r-6">商品名称</span>
        <el-input
          v-model="params.item_name"
          placeholder="请输入内容"
          class="input-m m-r-6"
          clearable
        />
      </li>
      <li>
        <span class="m-r-6">货号</span>
        <el-input
          v-model="params.item_bn"
          placeholder="请输入内容"
          class="input-m m-r-6"
          clearable
        />
      </li>
      <li>
        <span class="m-r-6">提成比例</span>
        <el-input
          v-model="params.proportion"
          placeholder="请输入内容"
          class="input-m m-r-6"
          clearable
        />
      </li>
      <li>
        <el-button
          type="primary"
          @click="searchList"
        >
          查询
        </el-button>
      </li>
    </ul>

    <div style="margin-bottom: 15px" />
    <el-table
      ref="multipleTable"
      v-loading="loading"
      :data="listData"
      tooltip-effect="dark"
    >
      <el-table-column
        prop="item_bn"
        width="200px"
        label="商品货号"
      />
      <el-table-column
        prop="item_name"
        label="商品名称"
      />
      <el-table-column
        prop="specification"
        label="规格"
      />
      <el-table-column
        prop="proportion"
        label="提成"
      >
        <template slot-scope="scope">
          <div v-if="scope.row.proportion">
            {{ scope.row.proportion }}%
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div
      slot="footer"
      class="dialog-footer select-footer"
    >
      <div>
        <el-pagination
          layout="total, prev, pager, next, jumper"
          :current-page="params.page"
          :total="total_count"
          :page-size="params.page_size"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'SpRulesGoodsSelect',
  model: {
    prop: 'goodsVisible',
    event: 'goodsVisibleChange'
  },
  props: {
    goodsVisible: {
      // 展示模态框
      type: Boolean,
      default: false
    },
    ruleId: {
      type: Number,
      default: 0
    },
    ladderNo: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      key: 1,
      listData: [],
      total_count: 0,
      loading: false,
      params: {
        page: 1,
        page_size: 10,
        item_name: '',
        item_bn: '',
        proportion: null
      }
    }
  },
  computed: {
    showDialog () {
      return this.goodsVisible
    }
  },
  watch: {
    goodsVisible (newVal, oldVal) {
      if (newVal) {
        this.getList()
      }
    }
  },
  methods: {
    // 分页器页面切换
    handleCurrentChange (page_num) {
      this.params.page = page_num
      this.getList()
    },
    // 关闭模态框
    cancelAction () {
      this.$emit('goodsVisibleChange', false)
    },
    async getList () {
      this.loading = true
      let params = Object.assign({}, this.params, {
        rule_id: this.ruleId,
        ladder_no: this.ladderNo
      })
      const data = await this.$api.customerConversion.getCommissionList(params)
      if (data) {
        this.listData = data.list
        this.total_count = data.total_count
        this.loading = false
      }
    },
    searchList () {
      this.params.page = 1
      this.getList()
    }
  }
}
</script>

<style lang="scss" scoped>
.search-btn {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 20px;
  li {
    margin-right: 20px;
  }
}
.select-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
